import classNames from 'classnames';
import styles from './index.module.css';

const Action = ({ Icon, action, iconProps }) => {
  return (
    <div className={styles.action} onClick={action}>
      <Icon className={styles.actionsIcon} {...iconProps} />
    </div>
  );
};

export const RideActionsPanel = ({ entities }) => {
  return (
    <div
      className={classNames({
        [styles.actionsButtons]: true,
        [styles.twoActionsButtons]: entities?.length <= 2,
        [styles.singleButton]: entities?.length === 1,
      })}>
      {entities.map((entity) => (
        <Action Icon={entity.Icon} action={entity.action} key={entity.id} iconProps={entity.iconProps} />
      ))}
    </div>
  );
};
